import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IMessageRecipient } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class MessageRecipientService extends BaseService<IMessageRecipient> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'messageRecipient');
  }
}

export { IMessageRecipient } from '../shared/api';
